<template>
  <div class="row text-center py-3">
    <div class="col-12">
      <i class="fas fa-volume-up"></i>
      <span class="text-uppercase ms-2">
        {{ component.text || type }}
      </span>
    </div>
    <div class="col-12 mt-4">
        <audio style="width: 100%;" controls controlsList="nodownload" :src="path" ref="audio">
          Your browser does not support the
          <code>audio</code>
          element.
        </audio>
    </div>
    <div class="col-12 mt-4" v-if="component.data.download">
      <a :href="path" :download="filename" target="_blank" class="btn btn-primary">
        {{ 'Download' | translate }}
      </a>
    </div>
  </div>
</template>

<script>
import slugify from 'slugify'
import _includes from 'lodash/includes'

export default {
  props: ['component'],
  mounted() {
    let audio = this.$refs.audio
    if (audio) {
      audio.onended = this.ended
    }
  },
  computed: {
    filename() {
      return `${slugify(this.component.text || 'file')}.${this.type}`.toLowerCase()
    },
  },
  data() {
    if (this.component.file) {
      return {
        path: `https://djceg34j53tq.cloudfront.net/${this.component.file}`,
        type: this.component.file.split('.').pop(),
      }
    }
    return {
        path: `/`,
        type: 'txt',
    }
  },
  methods: {
    _includes,
    play() {
      let audio = this.$refs.audio
      if (audio) {
        audio.play()
      } else {
        this.ended()
      }
    },
    ended() {
      this.$emit('audioEnded', {component_id: this.component.id})
    },

  },
}
</script>
